import React from 'react';
import './AppModal.css';
import PaymentCard from './PaymentCard';
import flutterwave from '../../assets/icons/flutterwave.svg';
import interswitch from '../../assets/icons/interswitch.svg';
import { useNavigate } from 'react-router-dom';

type TModal = {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  setShowSuccessModal?: React.Dispatch<React.SetStateAction<boolean>>;
  amount?: string;
  redirect?: boolean;
};

const PaymentModal = ({ show, setShow, setShowSuccessModal, amount, redirect = true }: TModal) => {
  const navigate = useNavigate();

  const navigateToDashboard = () => {
    if (redirect) {
      navigate('/dashboard');
    }
  };
  return (
    <>
      {show ? (
        <section className='fixed z-[500000] top-0 left-0 right-0 bottom-0 bg-[#061A1480]'>
          <div className='container !max-w-[90%] w-full h-full flex items-center justify-center'>
            <section className='w-full max-w-[450px] z-10  bg-white rounded-xl '>
              <div className='w-full max-w-[450px] mx-auto space-y-[40px] py-[15px] px-[20px] md:p-[30px]'>
                <div className='modal-child-div'>
                  <div className='modal-div2'>
                    <div className='flex justify-between gap-2'>
                      <div>
                        <div className='text-[13px] md:text-[15px] font-[600]'>
                          Select your preferred payment channel
                        </div>
                        <div className='text-[11px] font-[500]'>
                          We accept Visa, MasterCard, and Verve.
                        </div>
                      </div>
                      <div
                        className='text-[red] font-[600] flex justify-center items-center text-[14px] cursor-pointer bg-[#ECECEC] rounded-[50%] p-2 w-[30px] h-[30px]'
                        onClick={() => {
                          setShow(false);
                          navigateToDashboard();
                        }}
                      >
                        X
                      </div>
                    </div>
                    <PaymentCard
                      image={flutterwave}
                      name='flutterwave'
                      func={setShowSuccessModal}
                      setShow={setShow}
                      amount={amount}
                      redirect={redirect}
                    />

                    {/* <PaymentCard
                      image={interswitch}
                      name='interswitch'
                      func={setShowSuccessModal}
                      setShow={setShow}
                      amount={amount}
                      redirect={redirect}
                    /> */}
                  </div>
                </div>
              </div>
            </section>
          </div>
        </section>
      ) : null}
    </>
  );
};

export default PaymentModal;
